export default __webpack_public_path__ + "static/media/fw-evelyn-er-Yellow Gold.0456f148.mp4";